const productData = [
  {
    id: 1,
    title: "Inception",
    url: "inception",
    director: "Christopher Nolan",
    releaseYear: 2010,
    genre: ["Action", "Adventure", "Sci-Fi"],
    rating: 8.8,
    description: "A thief who enters the dreams of others to steal secrets from their subconscious.",
    imageUrl: "https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p7825626_p_v8_af.jpg",
    price: 200,
    shares: 100000,
    uploader: "productionHouse1",
    trailer: "https://staging.moviemint.net/uploads/video/admin/video1.mp4"
  },
  {
    id: 2,
    title: "The Shawshank Redemption",
    url: "the-shawshank-redemption",
    director: "Frank Darabont",
    releaseYear: 1994,
    genre: ["Drama"],
    rating: 9.3,
    description: "Two imprisoned men bond over a number of years, finding solace and eventual redemption through acts of common decency.",
    imageUrl: "https://m.media-amazon.com/images/I/815qtzaP9iL._AC_UF1000,1000_QL80_.jpg",
    price: 20,
    shares: 13000,
    uploader: "productionHouse2",
    trailer: "https://www.youtube.com/watch?v=PLl99DlL6b4"
  },
  {
    id: 3,
    title: "Dune: Part Two",
    url: "dune-part-two",
    director: "Denis Villeneuve",
    releaseYear: 2024,
    genre: ["Adventure", "Drama", "Sci-Fi"],
    rating: 8.6,
    description: "Paul Atreides unites with Chani and the Fremen while seeking revenge against the conspirators who destroyed his family.",
    imageUrl: "https://media.wired.com/photos/65fcac844fae0541c55cab49/1:1/w_1147,h_1147,c_limit/Dune-Pt-2-Religous-Experience-Culture-rev-1-DUN2-47223rv3_High_Res_JPEG.jpg",
    price: 250,
    shares: 95000,
    uploader: "productionHouse3",
    trailer: "https://www.youtube.com/watch?v=Way9Dexny3w"
  },
  {
    id: 4,
    title: "Inside Out 2",
    url: "inside-out-2",
    director: "Kelsey Mann",
    releaseYear: 2024,
    genre: ["Animation", "Adventure", "Comedy"],
    rating: 8.2,
    description: "Riley navigates the complexities of adolescence with new emotions joining the mix.",
    imageUrl: "https://lumiere-a.akamaihd.net/v1/images/p_insideout2_now_available_disneyplus_d24c051c.jpeg",
    price: 180,
    shares: 120000,
    uploader: "productionHouse2",
    trailer: "https://www.youtube.com/watch?v=LEjhY15eCx0"
  },
  {
    id: 5,
    title: "Orion and the Dark",
    url: "orion-and-the-dark",
    director: "Sean Charmatz",
    releaseYear: 2024,
    genre: ["Animation", "Adventure", "Family"],
    rating: 7.5,
    description: "Orion, a young boy, confronts his fears when the embodiment of darkness pays him a visit.",
    imageUrl: "https://upload.wikimedia.org/wikipedia/en/b/b2/Orion_and_the_Dark_poster.jpg",
    price: 190,
    shares: 68000,
    uploader: "productionHouse3",
    trailer: "https://www.youtube.com/watch?v=5qap5aO4i9A"
  }
];

export default productData;
